import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
import {
  StyleHeading,
  StyleInfoTypography,
  StyleOrderList,
  StyleOrderListItem,
} from "../../assets/js/Theme";
import { injectIntl } from "react-intl";
import { DEFAULT_TEXT_LIMIT } from "../../resources/Constants";
const TermsAndConditions = (props) => {
  const { intl } = props;
  const TERMS_LIST_LENGTH = 8;
  const [showHideText, setShowHideText] = useState(false);
  return (
    <Grid container spacing={3} className="terms--wrapper">
      <Grid item xs={12}>
        <StyleHeading variant="h5" color="primary" gutterBottom>
          {intl.formatMessage({ id: "TERMS.HEADING.TERMS_AND_CONDITION" })}
        </StyleHeading>
        <Typography color="primary" variant="body2" gutterBottom>
          {intl.formatMessage({
            id: "TERMS.TEXT.SUMMARY",
          })}
        </Typography>
        {showHideText ? (
          <>
            <StyleOrderList component="ol">
              {[...Array(TERMS_LIST_LENGTH)].map((e, i) => (
                <StyleOrderListItem component="li" key={i}>
                  <Typography color="primary" variant="body2">
                    {intl.formatMessage({
                      id: `TERMS.POINTS.TERMS_${i + 1}`,
                    })}
                  </Typography>
                </StyleOrderListItem>
              ))}
            </StyleOrderList>
            <Typography color="primary" component="strong" variant="body2">
              {intl.formatMessage({
                id: "TERMS.HEADING.INTELLECTUAL_PROPERTY_RIGHTS",
              })}
            </Typography>
            <Typography
              color="primary"
              component="span"
              variant="body2"
              gutterBottom
            >
              {intl.formatMessage({
                id: "TERMS.HEADING.INTELLECTUAL_PROPERTY_RIGHTS_DETAIL",
              })}
            </Typography>
          </>
        ) : null}
      </Grid>
      <Grid item xs={12}>
        {DEFAULT_TEXT_LIMIT ? (
          <div>
            <StyleInfoTypography
              variant="body2"
              paragraph
              component="a"
              onClick={() => {
                setShowHideText(!showHideText);
              }}
            >
              {showHideText
                ? intl.formatMessage({ id: "GENERAL.VIEW_LESS" })
                : intl.formatMessage({ id: "GENERAL.VIEW_MORE" })}
            </StyleInfoTypography>
          </div>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default injectIntl(TermsAndConditions);
